// These models are 'getters' so that we do not create a reference to the original object.

import CONSTANTS from '@/constants/constants';

const MODELS = Object.freeze({
  get selectedDay() {
    return {
      yearNumber: null,
      monthNumber: null,
      dayNumber: null,
    };
  },
  get user() {
    return {
      email: null,
      fullName: null,
      isAdmin: null,
    };
  },
  get coupon() {
    return {
      id: null,
      images: [],
      normalPrice: null,
      newPrice: null,
      barcode: null,
      qrCode: null,
      title: null,
      text: '',
      discountPercentage: null,
      url: null,
      cta: CONSTANTS.couponCtaTypes.redeem.value,
    };
  },
  get campaign() {
    return {
      id: null,
      isDeleted: false,
      notificationTitle: null,
      notificationDescription: '',
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      delay: '',
      daysActive: [],
      coupons: [], // exclude from save campaign
    };
  },
  get stats() {
    return {
      uniqueVisitors: null,
      sentNotifications: null,
      clickThroughRate: null,
      averageCouponViewTime: null,
      redeemedCoupons: null,
    };
  },
  get organization() {
    return {
      name: null,
      subtitle: null,
      image: {},
      timezone: 'Europe/Amsterdam',
      users: [],
    };
  },
});

export default MODELS;
